export enum SharePointFilePreviewMethod {
    // Side-by-side preview not supported.
    Unsupported,

    // Use the image lightbox UI to render the attachment.
    Image,

    // Use OWA's calendar UI to reder the file (e.g. ICS).
    CalendarEvent,

    // Use the WAC to render the file (e.g. Office docs).
    Wac,

    // Use the audio player to render the file (e.g. MP3).
    Audio,

    // Render the file as plain text.
    Text,

    // Use the video player to render the file (e.g. MP4)
    Video,

    // Use iframe to render pdf files
    IFrame,
}
